import React from 'react';
import { Layout } from 'antd';
import './style.css';

const { Header: AntHeader } = Layout;

const Header: React.FC = () => {
  return (
    <AntHeader className="header">
      <div className="header-content">
        <div className="logo-container">

          <span className="title">王导导管理后台</span>
        </div>
      </div>
    </AntHeader>
  );
};

export default Header;
